/** Static lookups until inventory quotations API exists */

export const MOCK_CUSTOMERS = [
  { id: 1, name: 'Acme Trading Co.' },
  { id: 2, name: 'Blue Star Retail' },
  { id: 3, name: 'Gulf Supplies LLC' },
]

export const MOCK_WAREHOUSES = [
  { id: 1, name: 'Main warehouse' },
  { id: 2, name: 'Regional hub — East' },
  { id: 3, name: 'Outlet store stock' },
]

export const MOCK_PAYMENT_METHODS = [
  { id: 1, name: 'Cash' },
  { id: 2, name: 'Bank transfer' },
  { id: 3, name: 'Card' },
]

export const MOCK_PAYMENT_TERMS = [
  { id: 1, name: 'Net 15' },
  { id: 2, name: 'Net 30' },
  { id: 3, name: 'Due on receipt' },
]

export const MOCK_ITEMS = [
  { id: 101, name: 'SKU-101 — Office chair' },
  { id: 102, name: 'SKU-102 — LED panel 60W' },
  { id: 103, name: 'SKU-103 — Network cable (box)' },
  { id: 104, name: 'SKU-104 — Paper ream A4' },
]

export const MOCK_TAX_RATES = [
  { id: 1, name: 'VAT 15%', percent: 15 },
  { id: 2, name: 'VAT 5%', percent: 5 },
  { id: 3, name: 'Zero rated', percent: 0 },
]

export const MOCK_BATCHES_BY_ITEM: Record<string, Array<{ id: number; name: string }>> = {
  '101': [
    { id: 9001, name: 'BTH-101-A' },
    { id: 9002, name: 'BTH-101-B' },
  ],
  '102': [
    { id: 9101, name: 'BTH-102-A' },
    { id: 9102, name: 'BTH-102-B' },
  ],
  '103': [{ id: 9201, name: 'BTH-103-A' }],
  '104': [
    { id: 9301, name: 'BTH-104-A' },
    { id: 9302, name: 'BTH-104-B' },
  ],
}

export function mockAvailableQuantity(itemId: string, batchId: string, _warehouseId: string): number {
  const a = Number(itemId) || 0
  const b = Number(batchId) || 0
  return 20 + ((a * 13 + b * 7) % 180)
}
